import { Component } from '@angular/core';
import { PoUploadFile, PoBreadcrumb } from '@po-ui/ng-components';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-movimentacao',
  templateUrl: './movimentacao.component.html',
  styleUrl: '../../home/carga-inicial/carga-inicial.component.css',
  standalone: false,
})
export class MovimentacoesImportacoesComponent {
  rotas = [
    {
      tabela: '[JC8304]', url: environment.apiUrl + '/v1/movimentacao/despachos'
    },
    {
      tabela: '[JC8306]', url: environment.apiUrl + '/v1/movimentacao/nfe'
    },
    {
      tabela: '[JC8307]', url: environment.apiUrl + '/v1/movimentacao/ajuste-estoque'
    },
    {
      tabela: '[JC8309]',
      url: environment.apiUrl + '/v1/movimentacao/ordem-producao',
    },
    {
      tabela: '[JC8311]',
      url: environment.apiUrl + '/v1/movimentacao/devolucao',
    },
    {
      tabela: '[JC8314]',
      url: environment.apiUrl + '/v1/movimentacao/transferencia-ficha',
    }
  ];

  readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'CAT 83/2009' },
      { label: 'Carga de Dados' },
      { label: 'Movimentação' },
    ],
  };
}
